import React from "react";
import {
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { logos } from "apps/school-site/config/logos";
import HomeHeroesContainer from "../features/home/heroes/HomeHeroesContainer";
import { News } from "../features/news";
import { EducationOfferPanelAllCards } from "apps/school-site/features/education-offer-all-cards";
import { EducationOfferPanel } from "apps/school-site/features/education-offer";
import { ErasmusPanel } from "../features/erasmus";

import { VideosPanel } from "../features/videos";
import { MapPanel } from "../features/map";
import { PartnersPanel } from "../features/partners";
import { EduPanel } from "shared/components/EduPlatform";
import SchoolEduHero from "../features/edu-hero/components/SchoolEduHero";
import EducationDirectionsCarousel
  from "../features/education-direction/components/EducationDirectionsCarousel";

const SchoolHomePage = () => {
  // const html = document.documentElement;
  document.documentElement.classList.add("skillmeasure-theme");

  // html.classList.add(
  //   "pf-v6-theme-felt",
  //   "custom-school-theme"
  // );
  return (
    <Stack hasGutter>
      <StackItem>
        <EducationDirectionsCarousel />
      </StackItem>
      <StackItem isFilled />

      <StackItem>
        <PageSection>
          <HomeHeroesContainer />
        </PageSection>
      </StackItem>
      
      {/* <PageSection isWidthLimited>
        <EducationOfferPanel
          isLarge={false}
          isCard={false}
          actionHref="/candidate"
        />
      </PageSection> */}
      
      <StackItem isFilled />
      <StackItem isFilled />

      <StackItem>
        <PageSection>
          <News isCard={false} />
        </PageSection>
      </StackItem>
      <StackItem isFilled />
      <StackItem isFilled />
      
      {/* <PageSection isWidthLimited>
        <EducationOfferPanelAllCards
          isLarge={false}
          isCard={false}
          actionHref="/candidate"
        />
      </PageSection>

      <StackItem isFilled />
      <StackItem isFilled /> */}

      <StackItem>
        <PageSection>
          <ErasmusPanel />
        </PageSection>
      </StackItem>
      
      <StackItem isFilled />
      <StackItem isFilled />
      
      <StackItem>
        <PageSection>
          <EduPanel
            logos={logos}
            isCard={false}
            showHeader
            isCarousel={false}
            showAction={false}
            title="Platforma edukacyjna"
            description="Platforma edukacyjna zapewnia dostęp do materiałów egzaminacyjnych, zbiorów zadań, analiz wyników egzaminów oraz nowoczesnych środowisk laboratoryjnych wykorzystywanych w branży IT"
            actionLabel=""
            actionHref=""
            hero={<SchoolEduHero />}
          />
        </PageSection>
      </StackItem>
      <StackItem isFilled />
      <StackItem>
        <PageSection>
          <PartnersPanel
            isCard={false}
            showHeader
            title="Partnerzy"
            description="Nasza szkoła współpracuje z firmami i instytucjami, które wspierają rozwój uczniów, praktyki zawodowe oraz edukację."
          />
        </PageSection>
      </StackItem>
      <StackItem isFilled />
      <StackItem>
        <PageSection>
          <VideosPanel
            isCard
            showHeader
            isCarousel
            showAction={false}
            title="Nasze filmy"
            description="Zobacz filmy prezentujące naszą szkołę."
            actionLabel="Zobacz więcej na YouTube"
            actionHref="https://www.youtube.com/@ckziuwyrzysk4051"
          />
        </PageSection>
      </StackItem>

      <StackItem>
        <PageSection>
          <MapPanel
            isCard={false}
            showHeader
            showAction
            title="Mapa dojazdu"
            description="Lokalizacja szkoły - sprawdź, jak do nas trafić."
            locationLabel="Lokalizacja"
            locationTitle={false}
            locationDescription={false}
            mapSrc="https://maps.google.com/maps?q=Centrum%20Kszta%C5%82cenia%20Zawodowego%20i%20Ustawicznego%20w%20Wyrzysku&t=k&z=15&output=embed"
            actionLabel={false}
            actionHref={false}
          />
        </PageSection>
      </StackItem>
    </Stack>
  );
};

export default SchoolHomePage;